import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SfAnalyticsStore {
  private sfAnalyticsSubject = new BehaviorSubject<any>(undefined);
  private sfAnalytics$ = this.sfAnalyticsSubject.asObservable().pipe(distinctUntilChanged());

  private sfObjectDocumentationSubject = new BehaviorSubject<any>(undefined);
  private sfObjectDocumentation$ = this.sfObjectDocumentationSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  private percentageFilledSubject = new BehaviorSubject<any>(undefined);
  private percentageFilled$ = this.percentageFilledSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  private descriptionFilledOverTimeSubject = new BehaviorSubject<any>(undefined);
  private descriptionFilledOverTime$ = this.descriptionFilledOverTimeSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  private gdprFieldStatusSubject = new BehaviorSubject<any>(undefined);
  private gdprFieldStatus$ = this.gdprFieldStatusSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  private gdprFieldStatusOverTimeSubject = new BehaviorSubject<any>(undefined);
  private gdprFieldStatusOverTime$ = this.gdprFieldStatusOverTimeSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  private gdprLegalBasisSubject = new BehaviorSubject<any>(undefined);
  private gdprLegalBasis$ = this.gdprLegalBasisSubject.asObservable().pipe(distinctUntilChanged());

  private printPageSubject = new BehaviorSubject<any>(false);
  private printPage$ = this.printPageSubject.asObservable().pipe(distinctUntilChanged());

  /*private customFieldsPerObjectWithImpactAnalysisChartSubject = new BehaviorSubject<any>(undefined);
  private customFieldsPerObjectWithImpactAnalysisChart$ = this.printPageSubject.asObservable().pipe(distinctUntilChanged());*/

  private bigChartIsLoadingSubject = new BehaviorSubject<any>(undefined);
  private bigChartIsLoading$ = this.bigChartIsLoadingSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  private sfAnalyticsActiveBlockSubject = new BehaviorSubject<string>(undefined);
  private sfAnalyticsActiveBlock$ = this.sfAnalyticsActiveBlockSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  public cachedData: any = {
    sfObjectDocumentation: {}
  };

  get activeChart() {
    return this.sfAnalyticsActiveBlockSubject.value;
  }

  get sfAnalytics() {
    return this.sfAnalyticsSubject.value;
  }

  get sfObjectDocumentation() {
    return this.sfObjectDocumentationSubject.value;
  }

  get percentageFilled() {
    return this.percentageFilledSubject.value;
  }

  get descriptionFilledOverTime() {
    return this.descriptionFilledOverTimeSubject.value;
  }

  get gdprFieldStatus() {
    return this.gdprFieldStatusSubject.value;
  }

  get gdprFieldStatusOverTime() {
    return this.gdprFieldStatusOverTimeSubject.value;
  }

  get gdprLegalBasis() {
    return this.gdprLegalBasisSubject.value;
  }

  get printPage() {
    return this.printPageSubject.value;
  }

  // get customFieldsPerObjectWithImpactAnalysisChart() {
  //   return this.customFieldsPerObjectWithImpactAnalysisChartSubject.value;
  // }

  select<T>(name: string): Observable<T> {
    return this[`${name}$`];
  }

  set(name: string, stateValue: any) {
    this[`${name}Subject`].next(stateValue);
  }
}
